module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Loading-e6ae32096b1ab271ebff9d6785587b3b.svg";